import Claims from '../pages/billings/Claims';
import ClaimInfo from '../pages/billings/ClaimInfo';
import InvoiceList from '../pages/billings/InvoiceList';
import { Roles } from '../constants';
import InvoiceDetails from '../pages/billings/InvoiceDetails';
import BuildAndPreviewInvoice from '../pages/billings/BuildAndPreviewInvoice';
import InvoicePayment from '../pages/billings/InvoicePayment';

export const billingRoutes = [
  {
    path: '/billings/claims',
    type: 'private',
    elem: <Claims />,
    roles: [Roles.Admin, Roles.ClientSuccessManager, Roles.Biller],
  },
  {
    path: '/billings/claims/:claimId',
    type: 'private',
    elem: <ClaimInfo />,
    roles: [Roles.Admin, Roles.ClientSuccessManager, Roles.Biller, Roles.InvoiceCoordinator],
  },
  {
    path: '/billings/invoice-list',
    type: 'private',
    elem: <InvoiceList />,
    roles: [Roles.Guardian, Roles.Prbt, Roles.LimitedAccessGuardian],
  },
  {
    path: '/billings/invoice-payment/:invoiceId',
    type: 'private',
    elem: <InvoicePayment />,
    roles: [Roles.Guardian, Roles.Prbt, Roles.LimitedAccessGuardian],
  },
  {
    path: '/billings/invoice-builder',
    type: 'private',
    elem: <BuildAndPreviewInvoice />,
    roles: [Roles.InvoiceCoordinator],
  },
  {
    path: '/billings/invoice/:invoiceId',
    type: 'private',
    elem: <InvoiceDetails />,
    roles: [
      Roles.Admin,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
      Roles.LimitedAccessGuardian,
    ],
  },
];
